import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    IGetActiveServicesAction,
    IGetActiveServicesSuccessAction,
    IGetActiveServicesErrorAction,
} from '../actions/acitve-services/get-active-services';
import { IStoreIntState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadActiveServicesAction
    = IGetActiveServicesAction
    | IGetActiveServicesSuccessAction
    | IGetActiveServicesErrorAction;

const init = (state: IStoreIntState, action: LoadActiveServicesAction) => ({
    ...state,
    activeServices: {
        ...state.activeServices,
        status: action.status
    }
});

const success = (state: IStoreIntState, action: LoadActiveServicesAction) => ({
    ...state,
    activeServices: {
        status: action.status,
        data: (action as IGetActiveServicesSuccessAction).data
    }
});

const failure = (state: IStoreIntState, action: LoadActiveServicesAction) => ({
    ...state,
    activeServices: {
        ...initialState.activeServices,
        status: action.status,
        error: (action as IGetActiveServicesErrorAction).error
    }
});

export const loadActiveServicesReducer = createAsyncReducer(initialState, init, success, failure);